module.exports = __webpack_public_path__ + "static/media/consulta.aa60e957.svg";